import { useCallback, useState } from 'react'
import { STORY_OVERVIEW_TILE_SET } from 'services/sets/story'
import { useService } from 'services/utils/context'
import { useStoryOverviewPageStore, useUserStore } from 'store/context'
import StoriesPageViewStore from 'store/pages/stories'
import { Tile } from 'uiComponents/molecules/TileGrid/RowBuilder'

export const useRequestMoreStories = () => {
  const service = useService()
  const storyOverviewPageStore = useStoryOverviewPageStore()
  const currentStoryIds = useStoryOverviewPageStore(store => store.storyIds)
  const totalBatches = useStoryOverviewPageStore(store => store.totalBatches)

  const gender = useUserStore(store => store.gender)

  const [loading, setLoading] = useState(false)

  const requestMoreStories = useCallback(async () => {
    const nextBatchNumber = storyOverviewPageStore.currentBatchNumber + 1

    setLoading(true)

    const { storyIds } = await service.stories.requestStories(
      gender,
      STORY_OVERVIEW_TILE_SET,
      {
        pageNumber: nextBatchNumber,
        perPage: StoriesPageViewStore.storiesPerBatch,
      },
    )

    const updatedStoryIds = [...currentStoryIds, ...storyIds]

    const reachedEnd = nextBatchNumber >= totalBatches

    storyOverviewPageStore.reset({
      storyIds: updatedStoryIds,
      currentBatchNumber: nextBatchNumber,
      reachedEndOfStream: reachedEnd,
    })

    const tiles: Tile[] = updatedStoryIds.map(storyId => ({
      type: 'story',
      id: storyId,
    }))
    setLoading(false)

    storyOverviewPageStore.rowBuilder.resetTiles(tiles)
  }, [currentStoryIds, totalBatches, gender])

  return { requestMoreStories, loading }
}

export const getContentTypeFilters = (filters: { [key: string]: string }) => {
  return Object.keys(filters).filter(
    key => key === 'contentTypes' && filters[key] !== 'all',
  )
}
